import React, { useEffect } from 'react';
import { Alert, Box } from '@mui/material';

const SuccessAlert = ({ message, onClose, duration = 4000 }) => {
  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        onClose?.(); // Call onClose if provided
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [message, duration, onClose]);

  if (!message) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 16,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 1300,
        minWidth: 300,
        maxWidth: '80%',
      }}
    >
      <Alert severity="success" variant="filled">
        {message}
      </Alert>
    </Box>
  );
};

export default SuccessAlert;
